// Australian date formatting helpers.
//
// The CRM is used by a Melbourne agency, so dates must read DD/MM/YYYY. Plain
// `new Date(x).toLocaleDateString()` follows the *browser* locale, which on a
// US-configured machine renders MM/DD/YYYY (e.g. "8/4/2026" for 4 Aug) — the bug
// the client reported on the dashboard. Forcing the 'en-AU' locale fixes it
// regardless of the agent's OS/browser settings.

// DD/MM/YYYY (e.g. "04/08/2026").
export const formatDateAU = (value) => {
  if (!value) return '';
  const d = value instanceof Date ? value : new Date(value);
  if (Number.isNaN(d.getTime())) return '';
  return d.toLocaleDateString('en-AU', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
  });
};

// DD/MM/YYYY + time (e.g. "04/08/2026, 9:00 am").
export const formatDateTimeAU = (value) => {
  if (!value) return '';
  const d = value instanceof Date ? value : new Date(value);
  if (Number.isNaN(d.getTime())) return '';
  return d.toLocaleString('en-AU', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
    hour: 'numeric',
    minute: '2-digit',
  });
};

// Time only (e.g. "9:00 am").
export const formatTimeAU = (value) => {
  if (!value) return '';
  const d = value instanceof Date ? value : new Date(value);
  if (Number.isNaN(d.getTime())) return '';
  return d.toLocaleTimeString('en-AU', { hour: 'numeric', minute: '2-digit' });
};
